import React from 'react';
import * as Styled from './KlaraAndWhatsapp.styled';

interface Lab {
  labelText: string;
  number: string;
  usesKlara?: boolean;
}

interface WhatsappDetailsProps {
  lab: Lab;
}

const WhatsappDetails = ({ lab }: WhatsappDetailsProps) => {
  const message = encodeURI('I have more questions.\nCan you help me?');

  return (
    <>
      <Styled.Label>Send a Whatsapp Message</Styled.Label>
      <Styled.Text>
        <a href={`https://api.whatsapp.com/send?phone=${lab.number}&text=${message}`}>
          {lab.labelText}
        </a>
      </Styled.Text>
    </>
  );
};

export default WhatsappDetails;
